<!-- AdminLayout.vue -->
<template>
    <div id="dtr-wrapper" class="clearfix">
        <Headerr />
         <router-view></router-view>
        <Footerr />
    </div>
  </template>
  
  <script>
  import Headerr from "../components/userLayout/Header.vue";
  import Footerr from "../components/userLayout/Footer.vue";
  
  export default {
    name: "AdminLayout",
    components: { Headerr, Footerr },
    mounted() {},
    //     methods: {
//     loadScripts() {
//       const scripts = [
//         "../../public/assets/jsLanding/jquery.min.js",
//         "../../public/assets/jsLanding/bootstrap.min.js",
//         "../../public/assets/jsLanding/plugins.js",
//         "../../public/assets/jsLanding/slick.min.js",
//         "../../public/assets/jsLanding/custom.js"
//       ];

//       scripts.forEach(src => {
//         const script = document.createElement('script');
//         script.src = src;
//         script.async = true;
//         document.body.appendChild(script);
//       });
//     }
//   },
//   beforeCreate(){
//     this.loadScripts()
//   }
  };
  </script>
  
<style scoped src="../../public/assets/cssLanding/bootstrap.min.css"></style>
<style scoped src="../../public/assets/cssLanding/bootstrap.min.css"></style>
<style scoped src="../../public/assets/fontsLanding/iconfonts.css"></style>
<style scoped src="../../public/assets/cssLanding/plugins.css"></style>
<style scoped src="../../public/assets/cssLanding/style.css"></style>
<style scoped src="../../public/assets/cssLanding/responsive.css"></style>
<style scoped src="../../public/assets/cssLanding/color.css"></style>
  